import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiLogOut } = FiIcons;

const Navigation = ({ onLogout }) => {
  const navItems = [
    { name: 'Executive', id: 'executive' },
    { name: 'Sales', id: 'sales' },
    { name: 'Marketing', id: 'marketing' },
    { name: 'Creative', id: 'creative' },
    { name: 'Operations', id: 'operations' },
    { name: 'Live', id: 'live' },
  ];

  return (
    <nav className="sticky top-0 z-50 w-full bg-[#FCFAF6]/90 backdrop-blur-md border-b border-[#D9CCBA]/50 transition-all duration-300">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <div className="text-[#2F2B28] font-serif text-xl tracking-wide font-medium shrink-0">
          Padua Weddings
        </div>
        
        <div className="hidden lg:flex items-center space-x-6">
          {navItems.map((item) => (
            <a 
              key={item.id}
              href={`#${item.id}`} 
              className="text-[10px] tracking-widest uppercase text-[#2F2B28]/70 hover:text-[#6E7451] transition-colors"
            >
              {item.name}
            </a>
          ))}
          
          <div className="h-4 w-px bg-[#D9CCBA]/50 mx-2"></div>
          
          <button 
            onClick={onLogout}
            className="flex items-center space-x-2 text-[10px] tracking-widest uppercase text-red-600/70 hover:text-red-600 transition-colors"
          >
            <SafeIcon icon={FiLogOut} className="w-3.5 h-3.5" />
            <span>Logout</span>
          </button>
        </div>
        
        {/* Mobile Logout Only */}
        <button 
          onClick={onLogout}
          className="lg:hidden p-2 text-red-600/70"
          aria-label="Logout"
        >
          <SafeIcon icon={FiLogOut} className="w-5 h-5" />
        </button>
      </div>
    </nav>
  );
};

export default Navigation;